<template>
  <vs-row vs-justify="center" id="customers-box">
    <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-xs="12"
    >
      <vs-card>
        <vs-row class="w-25">
          <vs-col vs-w="8"></vs-col>

          <vs-col vs-w="2">
            <vs-button
                id="add-service-form"
                class="mr-2 w-100"
                icon="add"
                color="primary"
                @click="openAddCustomer()"
            >{{ $t("Customer.AddCustomerButton") }}
            </vs-button
            >
          </vs-col>
        </vs-row>
      </vs-card>
      <CustomizerSidebar
          ref="AddCustomer"
          @hide="hide"
          :customer_new="true"
          :sideBarTitle="$t('Service.AddServiceButton')"
      ></CustomizerSidebar>
      <vs-card>

        <div slot="header">
          <!-- DELETE PROMPT -->
          <div class="centerx con-exemple-prompt">
            <vs-prompt
                @accept="deleteCustomers(selected.id)"
                color="danger"
                @cancel="Closed"
                @close="Closed"
                :active.sync="activeDeletePrompt"
            >
              <div class="con-exemple-prompt">
                Are you sure to delete
                {{ selected.name }}
                account ?
              </div>
            </vs-prompt>
          </div>

          <!-- APPROVED/DISAPPROVED PROMPT -->

          <div class="centerx con-exemple-prompt">
            <vs-prompt
                @accept="updateApproval(selected.approved, selected.id)"
                color="success"
                @cancel="Canceled"
                @close="Canceled"
                :active.sync="activeApprovalPrompt"
            >
              <div class="con-exemple-prompt">
                {{
                  $t("Company.Approved.Popup")[Number(selected.approved)] +
                  " " +
                  selected.name +
                  " ?"
                }}
              </div>
            </vs-prompt>
          </div>
        </div>

        <vs-tabs :value="activeTab">
          <!-- ALL CUSTOMERS TAB -->

          <vs-tab
              :label="$t('Customer.Tabs.All')"
              icon="list_alt"
              id="all-tab"
              @click="showAll"
          >
            <vs-table
                :sst="true"
                @search="handleSearch"
                @selected="handleSelected"
                v-model="selected"
                :total="totalItems"
                max-items="10"
                search
                :data="businesses"
            >
              <template slot="thead">
                <vs-th sort-key="contactname">{{
                    $t("Customer.Table.FullName")
                  }}
                </vs-th>
                <vs-th sort-key="joindate">{{ $t("Customer.Email") }}</vs-th>
                <vs-th sort-key="phone">{{ $t("Customer.PhoneNumber") }}</vs-th>
                <vs-th sort-key="book_id">{{
                    $t("Customer.Table.Address")
                  }}
                </vs-th>
                <vs-th>{{ $t("Customer.Table.Approved") }}</vs-th>
                <vs-th>{{ $t("Customer.Table.Options") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].fname">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">
                          {{ data[indextr].fname }} {{ data[indextr].lname }}
                        </h5>
                        <span class="text-muted">{{ data[indextr].name }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].email }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].phone">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-phone-classic mr-2 display-8"></i>
                      <span class="text-muted">{{ data[indextr].phone }}</span>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].country">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].address }} ,{{ data[indextr].country }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].approved">
                    <vs-switch
                        color="success"
                        v-model="data[indextr].approved"
                        @input="
                        approvedPromptMember(
                          data[indextr].approved,
                          data[indextr].id
                        )
                      "
                    >
                      <!--updateApproval(data[indextr].approved,data[indextr].id) -->
                    </vs-switch>
                  </vs-td>
                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                          radius
                          color="primary"
                          type="border"
                          icon="visibility"
                          @click="showCustomer(data[indextr].id)"
                      ></vs-button>
                      <vs-button
                          id="edit-customer-button"
                          radius
                          color="warning"
                          type="border"
                          icon="edit"
                          @click="updateCustomer(data[indextr].id)"
                      ></vs-button>
                      <vs-button
                          radius
                          color="danger"
                          type="border"
                          icon="delete"
                          @click="deletePromptMember(data[indextr].id)"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination
                @change="handleChangePage"
                :total="totalPages"
                v-model="currentPage"
            ></vs-pagination>
          </vs-tab>

          <!-- APPROVED CUSTOMERS TAB -->

          <vs-tab
              :label="$t('Customer.Tabs.Approved')"
              icon="check_box"
              id="approved-tab"
              @click="showApproved"
          >

            <vs-table
                :sst="true"
                v-model="selected"
                :total="totalItems"
                @search="handleSearch2"
                max-items="10"
                search
                :data="approvedBusinesses"
            >
              <template slot="thead">
                <vs-th sort-key="contactname">{{
                    $t("Customer.Table.FullName")
                  }}
                </vs-th>
                <vs-th sort-key="joindate">{{ $t("Customer.Email") }}</vs-th>
                <vs-th sort-key="phone">{{ $t("Customer.PhoneNumber") }}</vs-th>
                <vs-th sort-key="book_id">{{
                    $t("Customer.Table.Address")
                  }}
                </vs-th>
                <vs-th>{{ $t("Customer.Table.Approved") }}</vs-th>
                <vs-th>{{ $t("Customer.Table.Options") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].fname">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">
                          {{ data[indextr].fname }} {{ data[indextr].lname }}
                        </h5>
                        <span class="text-muted">{{ data[indextr].name }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].email }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].phone">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-phone-classic mr-2 display-8"></i>
                      <span class="text-muted">{{ data[indextr].phone }}</span>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].country">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].address }} ,{{ data[indextr].country }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].approved">
                    <vs-switch
                        color="success"
                        v-model="data[indextr].approved"
                        @input="
                        approvedPromptMember(
                          data[indextr].approved,
                          data[indextr].id
                        )
                      "
                    >
                      <!--updateApproval(data[indextr].approved,data[indextr].id) -->
                    </vs-switch>
                  </vs-td>

                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                          radius
                          color="primary"
                          type="border"
                          icon="visibility"
                          @click="showCustomer(data[indextr].id)"
                      ></vs-button>
                      <vs-button
                          id="edit-customer-button"
                          radius
                          color="warning"
                          type="border"
                          icon="edit"
                          @click="updateCustomer(data[indextr].id)"
                      ></vs-button>
                      <vs-button
                          radius
                          color="danger"
                          type="border"
                          icon="delete"
                          @click="deletePromptMember(data[indextr].id)"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination
                @change="handleChangeApprovedPage"
                :total="totalApprovedPages"
                v-model="currentApprovedPage"
            ></vs-pagination>
          </vs-tab>

          <!-- DISAPPROVED CUSTOMERS TAB -->

          <vs-tab
              :label="$t('Customer.Tabs.Disapproved')"
              icon="cancel"
              id="disapproved-tab"
              @click="showDisapproved"
          >
            <vs-table
                :sst="true"
                @selected="handleSelected"
                @search="handleSearch3"
                v-model="selected"
                :total="totalItems"
                max-items="10"
                search
                :data="disapprovedBusinesses"
            >
              <template slot="thead">
                <vs-th sort-key="contactname">{{
                    $t("Customer.Table.FullName")
                  }}
                </vs-th>
                <vs-th sort-key="joindate">{{ $t("Customer.Email") }}</vs-th>
                <vs-th sort-key="phone">{{ $t("Customer.PhoneNumber") }}</vs-th>
                <vs-th sort-key="book_id">{{
                    $t("Customer.Table.Address")
                  }}
                </vs-th>
                <vs-th>{{ $t("Customer.Table.Approved") }}</vs-th>
                <vs-th>{{ $t("Customer.Table.Options") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].fname">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">
                          {{ data[indextr].fname }} {{ data[indextr].lname }}
                        </h5>
                        <span class="text-muted">{{ data[indextr].name }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].email }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].phone">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-phone-classic mr-2 display-8"></i>
                      <span class="text-muted">{{ data[indextr].phone }}</span>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].country">
                    <div class="d-flex align-items-center">
                      {{ data[indextr].address }} ,{{ data[indextr].country }}
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].approved">
                    <vs-switch
                        color="success"
                        v-model="data[indextr].approved"
                        @input="
                        approvedPromptMember(
                          data[indextr].approved,
                          data[indextr].id
                        )
                      "
                    >
                      <!--updateApproval(data[indextr].approved,data[indextr].id) -->
                    </vs-switch>
                  </vs-td>

                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                          radius
                          color="primary"
                          type="border"
                          icon="visibility"
                          @click="showCustomer(data[indextr].id)"
                      ></vs-button>
                      <vs-button
                          id="edit-customer-button"
                          radius
                          color="warning"
                          type="border"
                          icon="edit"
                          @click="updateCustomer(data[indextr].id)"
                      ></vs-button>
                      <vs-button
                          radius
                          color="danger"
                          type="border"
                          icon="delete"
                          @click="deletePromptMember(data[indextr].id)"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination
                @change="handleChangeDisapprovedPage"
                :total="totalDisapprovedPages"
                v-model="currentDisapprovedPage"
            ></vs-pagination>
          </vs-tab>
        </vs-tabs>
      </vs-card>
      <v-tour name="CustomersA" :steps="steps">
        <template slot-scope="tour">
          <transition name="fade">
            <v-step
                v-for="(step, index) of tour.steps"
                v-if="tour.currentStep === index"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
            >
              <template v-if="tour.currentStep === 0">
                <div slot="actions" class="v-step__buttons">
                  <button @click="promptShow" class="v-step__button">
                    Next
                  </button>
                </div>
              </template>
              <template v-if="tour.currentStep === 1">
                <div slot="actions" class="v-step__buttons">
                  <button @click="tour.previousStep" class="v-step__button">
                    Previous
                  </button>
                  <button @click="goToNextPage" class="v-step__button">
                    Next
                  </button>
                </div>
              </template>
            </v-step>
          </transition>
        </template>
      </v-tour>
    </vs-col>
  </vs-row>
</template>

<script>
import {businessService} from "../../_services";
import router from "../../_helpers/router";
import CustomizerSidebar from "../../layout/full/customizer/CustomizerSidebar.vue";
// moment

export default {
  name: "Customers",
  data: () => ({
    title: "Customers",
    activePrompt: false,
    activeDeletePrompt: false,
    activeUpdatePrompt: false,
    activeBookPrompt: false,
    activeUploadPrompt: false,
    activeTab: 0,
    activeApprovalPrompt: false,
    businesses: [],
    approvedBusinesses: [],
    disapprovedBusinesses: [],
    selected: {},
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    totalApprovedPages: 0,
    currentApprovedPage: 1,
    totalDisapprovedPages: 0,
    currentDisapprovedPage: 1,
    maxItems: 0,
    importModal: {
      file: null,
    },
    steps: [
      {
        target: "#add-customer-form", // We're using document.querySelector() under the hood
        header: {
          title: "Get Started",
        },
        params: {
          placement: "right-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#edit-customer-button",
        params: {
          placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ],
    errors: {
      firstName: false,
      lastName: false,
      email: false,
      phoneNumber: false,
      libID: false,
      selected: {
        firstName: false,
        lastName: false,
        email: false,
        phoneNumber: false,
        libID: false,
      },
    },
    fname: "",
    lname: "",
    phone_number: "",
    address: "",
    email: "",
    notes: "",
    internalId: "",
    dateOfBirth: "",
    searchKeyword: "",
  }),
  methods: {


    handleSearch(keyword) {
      this.searchKeyword = keyword;

      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      if (keyword == "") {
        this.showLoading();
        businessService
            .getPage(1)
            .then(
                function (data) {
                  this.businesses = data.businesses.data;
                  this.totalItems = data.businesses.total;
                  this.maxItems = data.businesses.per_page;
                  this.totalPages = data.businesses.last_page;

                }.bind(this)
            )
            .finally(
                function () {
                  this.hideLoading();
                }.bind(this)
            );
      } else {
        this.searchTimeout = setTimeout(() => {
              this.showLoading();

              businessService
                  .search(keyword)
                  .then(
                      function (data) {
                        this.businesses = data.businesses;
                        this.totalPages = 1;
                      }.bind(this)
                  )
                  .finally(
                      function () {
                        this.hideLoading();
                      }.bind(this)
                  );
            }


            , 2000);
      }
    },


    handleSearch2(keyword) {
      this.searchKeyword = keyword;

      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      if (keyword == "") {
        this.approvedBusinesses = [];
        this.showLoading();
        businessService
            .getAllApproved()
            .then(
                function (data) {
                  this.approvedBusinesses = data.businesses.data;
                  this.totalItems = data.businesses.total;
                  this.maxItems = data.businesses.per_page;
                  this.totalApprovedPages = data.businesses.last_page;

                }.bind(this)
            )
            .finally(
                function () {
                  this.hideLoading();
                }.bind(this)
            );
      } else {
        this.searchTimeout = setTimeout(() => {
              this.showLoading();

              businessService
                  .search(keyword)
                  .then(
                      function (data) {
                        this.approvedBusinesses = data.businesses;
                        this.totalApprovedPages = 1;
                      }.bind(this)
                  )
                  .finally(
                      function () {
                        this.hideLoading();
                      }.bind(this)
                  );
            }


            , 2000);
      }
    },


    handleSearch3(keyword) {
      this.searchKeyword = keyword;

      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      if (keyword == "") {
        this.showLoading();
        businessService
            .getAllDisapproved()
            .then(
                function (data) {
                  this.disapprovedBusinesses = [];
                  this.disapprovedBusinesses = data.businesses.data;
                  this.totalItems = data.businesses.total;
                  this.maxItems = data.businesses.per_page;
                  this.totalDisapprovedPages = data.businesses.last_page;

                }.bind(this)
            )
            .finally(
                function () {
                  this.hideLoading();
                }.bind(this)
            );
      } else {
        this.searchTimeout = setTimeout(() => {
              this.showLoading();

              businessService
                  .search(keyword)
                  .then(
                      function (data) {
                        this.disapprovedBusinesses = data.businesses;
                        this.totalDisapprovedPages = 1;
                      }.bind(this)
                  )
                  .finally(
                      function () {
                        this.hideLoading();
                      }.bind(this)
                  );
            }


            , 2000);
      }
    },


    openAddCustomer() {
      this.$refs.AddCustomer.show();
      //console.log(this.$refs.a);
    },
    Closed() {
      this.$vs.notify({
        color: "danger",
        title: "Delete Cancel",
        text: "Cancelling!",
      });
    },
    Canceled() {
      this.selected.approved = !this.selected.approved;
      this.$vs.notify({
        color: "danger",
        title: "Approval Cancel",
        text: "Cancelling!",
      });
    },
    showCustomer(item) {
      this.$router.push("/customers/show/" + item);
    },
    updateCustomer(item) {
      this.$router.push("/customers/" + item + "/update");
    },
    updateApproval(approved, id) {
      console.log(approved);
      if (!approved) {
        this.showLoading();
        businessService
            .DisapprovedBusiness(id)
            .then((data) => {
              this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Customer.CreateCustomerPrompt.ToastSuccessMessage"),
                  "success"
              );
            })
            .catch(
                function () {
                  this.notify(
                      this.$t("Toasts.Error"),
                      this.$t("Customer.CreateCustomerPrompt.ToastFailMessage"),
                      "danger"
                  );
                }.bind(this)
            )
            .finally(
                function () {
                  console.log(this.activeTab);
                  businessService
                      .getAll()
                      .then(
                          function (data) {
                            this.businesses = data.businesses.data;
                            this.totalItems = data.businesses.total;
                            this.maxItems = data.businesses.per_page;
                            this.totalPages = data.businesses.last_page;
                            this.activeApprovalPrompt = false;
                            this.selected = null;
                          }.bind(this)
                      )
                      .finally(() => {
                        this.hideLoading();
                      });
                }.bind(this)
            );
      } else {
        this.showLoading();

        businessService
            .ApprovedBusiness(id)
            .then((data) => {
              this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Customer.CreateCustomerPrompt.ToastSuccessMessage"),
                  "success"
              );
            })
            .catch(
                function () {
                  this.notify(
                      this.$t("Toasts.Error"),
                      this.$t("Customer.CreateCustomerPrompt.ToastFailMessage"),
                      "danger"
                  );
                }.bind(this)
            )
            .finally(
                function () {
                  //     console.log(this.activeTab);
                  businessService
                      .getAll()
                      .then(
                          function (data) {
                            this.businesses = data.businesses.data;
                            this.totalItems = data.businesses.total;
                            this.maxItems = data.businesses.per_page;
                            this.totalPages = data.businesses.last_page;
                            this.activeApprovalPrompt = false;
                            this.selected = null;
                          }.bind(this)
                      )
                      .finally(() => {
                        this.hideLoading();
                      });
                }.bind(this)
            );
      }
    },
    deleteCustomers(id) {
      let self = this;
      businessService
          .deleteBusiness(id)
          .then(function (data) {
            self.$vs.notify({
              title: "succes delete",
              text: "account successfully deleted",
              position: "bottom-right",
              type: "success",
              color: "green",
            });
            router.go();
          })
          .bind(this);

      this.activeDeletePrompt = false;
      this.selected = null;
      // this.$router.push('/settings/team');S
    },
    approvedPromptMember(approved, item) {
      this.selected.id = item;
      this.selected.approved = approved;
      this.activeApprovalPrompt = true;
    },
    deletePromptMember(item) {
      this.selected.id = item;
      this.activeDeletePrompt = true;
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#customers-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#customers-box > .con-vs-loading");
    },
    updateCustomerCategory() {
      this.showLoading();
      this.activeBookPrompt = true;
      customerBookService
          .add(this.selected.book, this.selected.id)
          .then(
              function (data) {
                this.activeBookPrompt = false;
                this.notify(
                    this.$t("Toasts.Successful"),
                    this.$t("Customer.CustomerBookPrompt.ToastSuccessMessage"),
                    "success"
                );
              }.bind(this)
          )
          .catch(
              function () {
                this.notify(
                    this.$t("Toasts.Error"),
                    this.$t("Customer.CustomerBookPrompt.ToastFailMessage"),
                    "danger"
                );
              }.bind(this)
          )
          .finally(
              function () {
                this.hideLoading();
              }.bind(this)
          );
    },
    handleChangePage(page) {
      this.showLoading();
      businessService
          .getPage(page)
          .then(
              function (data) {
                this.businesses = data.businesses.data;
              }.bind(this)
          )
          .finally(() => {
            this.hideLoading();
          });
    },

    reset() {
      this.activePrompt = false;
      this.activeUpdatePrompt = false;
      this.activeBookPrompt = false;
      this.selected = [];
      this.fname = "";
      this.lname = "";
      this.phone_number = "";
      this.address = "";
      this.email = "";
      this.notes = "";
      this.importModal = {file: null};
    },
    validateFields() {
      this.errors.firstName = this.fname.length < 3 ? true : false;
      this.errors.lastName = this.lname.length < 3 ? true : false;
      this.errors.phoneNumber =
          this.phone_number.length < 3 ||
          !this.isValidPhoneNumber(this.phone_number)
              ? true
              : false;
      if (this.email.length > 0) {
        this.errors.email = this.isValidEmail(this.email) ? false : true;
      } else {
        this.errors.email = false;
      }

      let {firstName, lastName, phoneNumber, email} = this.errors;
      return !(firstName || lastName || phoneNumber || email);
    },

    validateUpdateCustomerFields() {
      this.errors.selected.firstName =
          !this.selected.fname || this.selected.fname.length < 3 ? true : false;
      this.errors.selected.lastName =
          !this.selected.lname || this.selected.lname.length < 3 ? true : false;
      this.errors.selected.phoneNumber =
          !this.selected.phone_number ||
          this.selected.phone_number.length < 3 ||
          !this.isValidPhoneNumber(this.selected.phone_number)
              ? true
              : false;
      if (this.selected.email && this.selected.email.length > 0)
        this.errors.selected.email = this.isValidEmail(this.selected.email)
            ? false
            : true;
      else this.errors.selected.email = false;

      let {firstName, lastName, phoneNumber, email} = this.errors.selected;

      return !(firstName || lastName || phoneNumber || email);
    },
    isValidPhoneNumber(value) {
      // let phoneNumber = this.phone_number;
      return /^[+\d]\d+$/.test(value);
    },
    isValidEmail: function (value) {
      let re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(value);
    },
    uploadFile() {
      let importForm = new FormData();
      importForm.append("file", document.getElementById("fileInput").files[0]);
      this.showLoading();
      businessService
          .upload(importForm)
          .then(function () {
          }.bind(this))
          .catch(
              function () {
                window.location.reload();
              }.bind(this)
          )
          .finally(
              function () {
                this.hideLoading();
              }.bind(this)
          );
    },
    showAll() {
      this.businesses = [];
      this.showLoading();
      businessService
          .getAll()
          .then(
              function (data) {
                this.businesses = data.businesses.data;
                this.totalItems = data.businesses.total;
                this.maxItems = data.businesses.per_page;
                this.totalPages = data.businesses.last_page;
              }.bind(this)
          )
          .finally(() => {
            this.hideLoading();
          });
    },
    showApproved() {
      this.approvedBusinesses = [];
      this.showLoading();
      businessService
          .getAllApproved()
          .then(
              function (data) {
                this.approvedBusinesses = data.businesses.data;
                this.totalItems = data.businesses.total;
                this.maxItems = data.businesses.per_page;
                this.totalApprovedPages = data.businesses.last_page;
              }.bind(this)
          )
          .finally(() => {
            this.hideLoading();
          });
    },
    handleChangeApprovedPage(page) {
      this.approvedBusinesses = [];
      this.showLoading();
      businessService
          .getApprovedByPage(page)
          .then(
              function (data) {
                this.approvedBusinesses = data.businesses.data;
              }.bind(this)
          )
          .finally(() => {
            this.hideLoading();
          });
    },
    showDisapproved() {
      this.showLoading();
      businessService
          .getAllDisapproved()
          .then(
              function (data) {
                this.disapprovedBusinesses = [];
                this.disapprovedBusinesses = data.businesses.data;
                this.totalItems = data.businesses.total;
                this.maxItems = data.businesses.per_page;
                this.totalDisapprovedPages = data.businesses.last_page;
              }.bind(this)
          )
          .finally(() => {
            this.hideLoading();
          });
    },
    handleChangeDisapprovedPage(page) {
      this.disapprovedBusinesses = [];
      this.showLoading();
      businessService
          .getDisapprovedBypage(page)
          .then(
              function (data) {
                this.disapprovedBusinesses = data.businesses.data;
              }.bind(this)
          )
          .finally(() => {
            this.hideLoading();
          });
    },
  },
  computed: {
    events() {
      return this.$store.state.contactEvents;
    },
    validateAddCustomerForm() {
      // return this.fname.length > 0;
      // return true
    },
  },

  components: {
    CustomizerSidebar,
  },

  mounted() {
    this.showLoading();
    businessService
        .getAll()
        .then(
            function (data) {
              this.businesses = data.businesses.data;
              this.totalItems = data.businesses.total;
              this.maxItems = data.businesses.per_page;
              this.totalPages = data.businesses.last_page;
            }.bind(this)
        )
        .finally(() => {
          this.hideLoading();
          console.log(this.businesses)
        });
  },
};
</script>
<style scoped>
.verified-icon {
  display: inline-block;
  font-size: 20px;
}

.mdi-check-circle {
  color: green;
}

.mdi-close-circle {
  color: red;
}
</style>